/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType';
import type { FxIdDomainEntitiesDocumentsDocumentGeo } from './FxIdDomainEntitiesDocumentsDocumentGeo';
import {
    FxIdDomainEntitiesDocumentsDocumentGeoFromJSON,
    FxIdDomainEntitiesDocumentsDocumentGeoFromJSONTyped,
    FxIdDomainEntitiesDocumentsDocumentGeoToJSON,
    FxIdDomainEntitiesDocumentsDocumentGeoToJSONTyped,
} from './FxIdDomainEntitiesDocumentsDocumentGeo';
import type { FxIdDomainEntitiesDocumentsGameDocumentVersion } from './FxIdDomainEntitiesDocumentsGameDocumentVersion';
import {
    FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSON,
    FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSONTyped,
    FxIdDomainEntitiesDocumentsGameDocumentVersionToJSON,
    FxIdDomainEntitiesDocumentsGameDocumentVersionToJSONTyped,
} from './FxIdDomainEntitiesDocumentsGameDocumentVersion';

/**
 * Представляет собой документ в игровой системе, например, "Пользовательское соглашение" или "Политика конфиденциальности".
 * @export
 * @interface FxIdDomainEntitiesDocumentsDocument
 */
export interface FxIdDomainEntitiesDocumentsDocument {
    /**
     * Идентификатор документа.
     * @type {number}
     * @memberof FxIdDomainEntitiesDocumentsDocument
     */
    Id: number;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType}
     * @memberof FxIdDomainEntitiesDocumentsDocument
     */
    DocumentType: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType;
    /**
     * Дата и время создания документа.
     * @type {Date}
     * @memberof FxIdDomainEntitiesDocumentsDocument
     */
    CreatedAt: Date;
    /**
     * Признак того, что документ активен и может использоваться.
     * @type {boolean}
     * @memberof FxIdDomainEntitiesDocumentsDocument
     */
    IsActive: boolean;
    /**
     * Игра, к которой относится документ.
     * @type {string}
     * @memberof FxIdDomainEntitiesDocumentsDocument
     */
    GameSystemName: string;
    /**
     * 
     * @type {FxIdDomainEntitiesDocumentsDocumentGeo}
     * @memberof FxIdDomainEntitiesDocumentsDocument
     */
    Geo: FxIdDomainEntitiesDocumentsDocumentGeo;
    /**
     * Коллекция версий этого документа.
     * @type {Array<FxIdDomainEntitiesDocumentsGameDocumentVersion>}
     * @memberof FxIdDomainEntitiesDocumentsDocument
     */
    Versions: Array<FxIdDomainEntitiesDocumentsGameDocumentVersion>;
}

/**
 * Check if a given object implements the FxIdDomainEntitiesDocumentsDocument interface.
 */
export function instanceOfFxIdDomainEntitiesDocumentsDocument(value: object): value is FxIdDomainEntitiesDocumentsDocument {
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('DocumentType' in value) || value['DocumentType'] === undefined) return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined) return false;
    if (!('IsActive' in value) || value['IsActive'] === undefined) return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('Geo' in value) || value['Geo'] === undefined) return false;
    if (!('Versions' in value) || value['Versions'] === undefined) return false;
    return true;
}

export function FxIdDomainEntitiesDocumentsDocumentFromJSON(json: any): FxIdDomainEntitiesDocumentsDocument {
    return FxIdDomainEntitiesDocumentsDocumentFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'],
        'DocumentType': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON(json['DocumentType']),
        'CreatedAt': (new Date(json['CreatedAt'])),
        'IsActive': json['IsActive'],
        'GameSystemName': json['GameSystemName'],
        'Geo': FxIdDomainEntitiesDocumentsDocumentGeoFromJSON(json['Geo']),
        'Versions': ((json['Versions'] as Array<any>).map(FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSON)),
    };
}

export function FxIdDomainEntitiesDocumentsDocumentToJSON(json: any): FxIdDomainEntitiesDocumentsDocument {
    return FxIdDomainEntitiesDocumentsDocumentToJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsDocumentToJSONTyped(value?: FxIdDomainEntitiesDocumentsDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'DocumentType': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON(value['DocumentType']),
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'IsActive': value['IsActive'],
        'GameSystemName': value['GameSystemName'],
        'Geo': FxIdDomainEntitiesDocumentsDocumentGeoToJSON(value['Geo']),
        'Versions': ((value['Versions'] as Array<any>).map(FxIdDomainEntitiesDocumentsGameDocumentVersionToJSON)),
    };
}

